import IC_MAX_CLOSE from "@/assets/video/ic_max_close.svg?react";
import IC_TO_MIN from "@/assets/video/ic_to_min.svg?react";
import IC_PLAY from "@/assets/video/ic_play.svg?react";
import IC_FORWARD from "@/assets/video/ic_forward.svg?react";
import IC_REWIND from "@/assets/video/ic_rewind.svg?react";
import UnfoldIcon from "@/assets/summary/unfold.svg";
import FoldIcon from "@/assets/summary/fold.svg";
import IC_ZOOM from "@/assets/video/ic_zoom.svg?react";
import IC_MIN_CLOSE from "@/assets/video/ic_min_close.svg?react";
import IC_CIRCLE_WARNING from "@/assets/video/ic_circle_warning.svg?react";
import IC_PAUSE from "@/assets/summary/ic_audio_pause.svg?react";
import { createPortal } from "react-dom";
import videoPlayerStore from "@/store/videoPlayer.store";
import './index.css'
import { Rnd } from "react-rnd";
import VideoPlayer from "../VideoPlayer";
import { debounce } from "@common/utils";
import Slider from "rc-slider";
import PlayRateModal from "../RateModal";
import summaryCommonStore from "@/store/summaryCommon.store";
import { useShallow } from "zustand/react/shallow";
import { useEffect, useRef, useState } from "react";
import { isMac } from "@/utils/platform";
import lottie from "lottie-web";
import data from "@/assets/xloading.json";
import Tooltip from "@/component/Tooltip";

interface IProp {
  isOpen: boolean;
}

export default function RealVideo(prop: IProp) {

  const { audioInfo } = summaryCommonStore(
    useShallow((state) => ({
      audioInfo: state.audioInfo
    }))
  );

  const type = videoPlayerStore((store) => store.windowType);
  const isPlaying = videoPlayerStore((store) => store.isPlaying);
  const totalTime = videoPlayerStore((store) => store.totalTime);
  const videoLoaded = videoPlayerStore((store) => store.videoLoaded);
  const totalDuration = videoPlayerStore((store) => store.totalDuration);
  const elapsedTime = videoPlayerStore((store) => store.elapsedTime);
  const elapsedDuration = videoPlayerStore((store) => store.elapsedDuration);
  const rateText = videoPlayerStore((store) => store.rateText);

  const [position, setPosition] = useState({ x: 0, y: 0 });

  const [width, setWidth] = useState(320);
  const [height, setHeight] = useState(185);

  const [showPopTool, setShowPopTool] = useState(false);
  const [showFullTool, setShowFullTool] = useState(false);
  const [showRateModal, setShowRateModal] = useState(false);
  const [videoWaiting, setVideoWaiting] = useState(false);
  const [videoError, setVideoError] = useState(false);

  const [slideUp, setSlideUp] = useState(true);

  const lottieRef = useRef(null);

  const rndRef = useRef<Rnd>(null);
  const slideInTransformY = useRef<number>(0); // 全屏视图下，Y轴有偏移值

  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event: { key: string; }) => {
      if (!isActive) return; // 如果组件不是激活状态，不处理按键事件

      if (event.key === 'ArrowLeft') {
        console.log('视频播放快退');
        handleBack();
      } else if (event.key === 'ArrowRight') {
        console.log('视频播放快进');
        handleForward();
      }
    };

    if (!videoLoaded || videoWaiting) {
      lottie.destroy();
      lottie.loadAnimation({
        container: lottieRef.current!,
        loop: true,
        autoplay: true,
        renderer: "svg",
        animationData: data,
      });
    } else {
      lottie.destroy();
    }

    window.addEventListener('keydown', handleKeyDown, { passive: false });

    return () => {
      lottie.destroy();
      window.removeEventListener('keydown', handleKeyDown);
    }
  }, [videoLoaded, videoWaiting, isActive]); // 添加 isActive 依赖

  if (!prop.isOpen) return null;

  const handleMouseDown = (e: MouseEvent) => {
    const initialX = e.clientX - position.x;
    const initialY = e.clientY - position.y;

    const handleMouseMove = (moveEvent: MouseEvent) => {
      const bodyWidth = document.body.clientWidth;
      const bodyHeight = document.body.clientHeight + slideInTransformY.current;
      let newX = moveEvent.clientX - initialX;
      let newY = moveEvent.clientY - initialY;

      // 限制x轴方向的位置
      if (newX < 0) {
        newX = 0;
      } else if (newX + width > bodyWidth) {
        newX = bodyWidth - width;
      }
      // 限制y轴方向的位置
      if (newY < slideInTransformY.current) {
        newY = slideInTransformY.current;
      } else if (newY + height > bodyHeight) {
        newY = bodyHeight - height;
      }
      setPosition({
        x: newX,
        y: newY
      });
    };

    document.addEventListener('mousemove', handleMouseMove);

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    };
    document.addEventListener('mouseup', handleMouseUp);
  };

  const play = () => {
    console.log('点击播放');
    videoPlayerStore.getState().play();
  }

  const pause = () => {
    console.log('点击暂停');
    videoPlayerStore.getState().pause();
  }

  const hideVideo = () => {
    setSlideUp(false);
    setTimeout(() => {
      videoPlayerStore.getState().pause();
      videoPlayerStore.getState().changeType("foot");
      videoPlayerStore.getState().reset();
    }, 300)
  }

  const toPopup = () => {
    const currPosition = rndRef.current?.getDraggablePosition();
    if (!currPosition) return;
    console.log('偏移量:', currPosition.y);
    slideInTransformY.current = -currPosition.y;
    videoPlayerStore.getState().changeType("popUp");
    setPosition({
      x: 420,
      y: slideInTransformY.current + 10
    });
  }

  // 滑块拖动快进，快退
  const changeValue = (val: number | number[]) => {
    handleSliderChange(val, true);
  };
  // 滑块拖动过程，更新进度条
  const changingValue = (val: number | number[]) => {
    handleSliderChange(val);
  };

  const handleChangePlayRate = (playRate: string) => {
    videoPlayerStore.getState().changeSpeed(playRate);
  }

  const handleSliderChange = (val: number | number[], seek?: boolean) => {
    if (typeof val !== "number") return;
    const time = (val / 100) * totalDuration;
    videoPlayerStore.getState().changeSchedule(time, seek ?? false);
  };

  const handleForward = debounce(() => {
    videoPlayerStore.getState().forwardPlay(5);
  });

  const handleBack = debounce(() => {
    videoPlayerStore.getState().backPlay(5);
  });

  return createPortal(
    <Rnd
      ref={rndRef}
      size={{ width: type === "fullScreen" ? document.body.clientWidth : width, height: type === "fullScreen" ? document.body.clientHeight : height }}
      className={`box select-none ${type === "fullScreen" ? `${slideUp ? "slideIn" : "slideOut"} w-full h-full flex flex-col items-center bg-black` : "relative rd-2 no_drag"}`}
      style={{ display: "flex" }}
      position={type === "popUp" ? { x: position.x, y: position.y } : { x: 0, y: 0 }}
      onMouseDown={type === "fullScreen" ? undefined : handleMouseDown}
      disableDragging
      enableResizing={type === "popUp"}
      lockAspectRatio
      bounds="body"
      onResizeStop={(e, direction, ref, delta, currPosition) => {
        console.log('onResizeStop e = ', e);
        console.log('onResizeStop direction = ', direction);
        console.log('onResizeStop delta = ', delta);
        console.log('onResizeStop currPosition = ', currPosition);
        if (type === "fullScreen") return;
        setWidth(parseInt(ref.style.width));
        setHeight(parseInt(ref.style.height));
        slideInTransformY.current = 0;
        setPosition({
          x: currPosition.x,
          y: currPosition.y
        });
      }}
      onMouseEnter={() => {
        setShowPopTool(true);
        setShowFullTool(true);
        setIsActive(true); // 鼠标进入时激活
      }}
      onMouseLeave={() => {
        setShowPopTool(false);
        setShowFullTool(false);
        setIsActive(false); // 鼠标离开时取消激活
      }}
    >
      {type === "fullScreen" && <div className="w-full h-10 flex justify-between items-center">
        <IC_MAX_CLOSE className={`w-7 h-7 z-99 cursor-pointer no_drag ${isMac() && window.LinkService ? 'ml-21' : 'ml-4'}`} onClick={hideVideo} />
        <Tooltip content="小窗播放"
          placement={"bottom"}
          builtinPlacements={{
            bottom: {
              points: ["tc", "bc"],
              offset: [-15, -5], // 下方间隔为7px
            },
          }}>
          <IC_TO_MIN className="w-7 h-7 z-99 cursor-pointer mr-4 no_drag" onClick={toPopup} />
        </Tooltip>
      </div>}
      <div className={`bg-black overflow-hidden ${type === "fullScreen" ? 'flex-1 w-full' : 'absolute w-full h-full rd-2'}`}>
        <VideoPlayer videoUrl={audioInfo!.videoSrc!}
          onLoadCb={() => { videoPlayerStore.getState().setVideoLoaded(true) }}
          onWaitCb={(waiting: boolean) => {
            console.log("收到waiting状态 = ", waiting);
            setVideoWaiting(waiting);
          }}
          onErrorCb={() => {
            console.log("收到error状态");
            setVideoError(true);
          }}
        />
      </div>
      {(type === "fullScreen" && !videoError) &&
        <div className="h-18 w-full flex flex-col z-99">
          {videoLoaded && (!isPlaying || showFullTool) && <Slider
            step={0.01}
            value={totalDuration ? (elapsedDuration / totalDuration) * 100 : 0}
            className={`slider`}
            onChangeComplete={changeValue}
            onChange={changingValue}
          />}
          {videoLoaded && (!isPlaying || showFullTool) && <div className="w-full h-full flex items-center relative px-4 text-size-3.5">
            {/* 中间部分 */}
            <div className="absolute left-1/2 -translate-x-50% flex items-center">
              <IC_FORWARD className="w-6 h-6 cursor-pointer mr-6" onClick={handleBack} />
              {isPlaying ? <IC_PAUSE className="w-12 h-12 cursor-pointer" onClick={pause} />
                : <IC_PLAY className="w-12 h-12 cursor-pointer" onClick={play} />}
              <IC_REWIND className="w-6 h-6 cursor-pointer ml-6" onClick={handleForward} />
            </div>
            <span className="text-white">{elapsedTime}</span>
            <span className="text-#FFFFFF80">/{totalTime}</span>
            <div className="flex-1"></div>
            <PlayRateModal
              visible={showRateModal}
              setVisible={setShowRateModal}
              playRate={rateText}
              setPlayRate={handleChangePlayRate}
              mode={"dark"}
            >
              <div className="select-none cursor-pointer text-white ">
                {`${rateText}X`}
                {showRateModal ? (
                  <img src={FoldIcon} className="size-4 h-4 ml-1.5" />
                ) : (
                  <img src={UnfoldIcon} className="size-4 h-4 ml-1.5" />
                )}
              </div>
            </PlayRateModal>
          </div>}
        </div>
      }
      {(type === "popUp" && (!isPlaying || showPopTool) && videoLoaded) &&
        <div className="absolute h-13 w-full flex flex-col bottom-0 tool rd-b-2 z-99">
          <Slider
            step={0.01}
            value={totalDuration ? (elapsedDuration / totalDuration) * 100 : 0}
            className={`slider`}
            onChangeComplete={changeValue}
            onChange={changingValue}
          />
          <div className="relative w-full h-full flex items-center px-2 text-size-3">
            <div className="absolute left-1/2 -translate-x-50% flex items-center">
              <IC_FORWARD className="w-4 h-4 cursor-pointer mr-2" onClick={handleBack} />
              {isPlaying ? <IC_PAUSE className="w-8 h-8 cursor-pointer" onClick={pause} />
                : <IC_PLAY className="w-8 h-8 cursor-pointer" onClick={play} />}
              <IC_REWIND className="w-4 h-4 cursor-pointer ml-2" onClick={handleForward} />
            </div>
            <span className="text-white">{elapsedTime}</span>
            <span className="text-#FFFFFF80">/{totalTime}</span>
            <div className="flex-1"></div>
            <Tooltip content="最大化"
              placement={"top"}
              builtinPlacements={{
                top: {
                  points: ["bc", "tc"],
                  offset: [0, 0],
                },
              }}>
              <IC_ZOOM className="w-6 h-6 mr-2 cursor-pointer hover:bg-#FFFFFF14 rd-2"
                onClick={() => {
                  videoPlayerStore.getState().changeType("fullScreen");
                }} />
            </Tooltip>
            <Tooltip content="收起"
              placement={"top"}
              builtinPlacements={{
                top: {
                  points: ["bc", "tc"],
                  offset: [0, 0],
                },
              }}>
              <IC_MIN_CLOSE className="w-6 h-6 cursor-pointer hover:bg-#FFFFFF14 rd-2" onClick={hideVideo} />
            </Tooltip>
          </div>
        </div>
      }
      {(!videoLoaded || videoWaiting) && <div className="absolute w-full h-full flex flex-col items-center justify-center">
        <div ref={lottieRef} className="w-16 h-16"></div>
        <span className="text-size-4 text-#FFFFFFCC mt-1 lh-9 drop-shadow-[0_4px_4px_#00000040]">视频载入中</span>
      </div>}
      {videoError && <div className="absolute flex flex-col items-center justify-center z-90 bg-black w-full h-full select-none rd-2">
        {type === "fullScreen" && <IC_CIRCLE_WARNING className="w-16 h-16" />}
        <span className="text-#FFFFFFCC text-size-4 mb-2">网络异常</span>
        <span className="text-#FFFFFF66 text-size-4">请试试<span className="ml-1 text-#4981F2 cursor-pointer"
          onClick={() => {
            setVideoError(false);
            videoPlayerStore.getState().reload();
          }}>刷新</span></span>
      </div>}
    </Rnd >,
    document.body
  );
}
